import { SettingsContext } from '../context/settingsContext'
import { useContext } from 'react'


// Returns the context and makes sure we are using it within the correct scope 
export const useSettingsContext = () => {
    const context = useContext(SettingsContext)
    if (!context) {
        throw Error('useSettingsContext must be used inside an useSettingsContext')
    }

    return context;
}